import React from 'react';
import './Section.css';

function KittenDevelopment() {
  const stages = [
    {
      week: 'Weeks 0 – 2',
      title: 'Neonatal Period',
      details: 'Born blind, deaf, and unable to regulate body temperature. Completely dependent on mother\'s colostrum for antibodies, warmth, and anogenital stimulation for excretion.'
    },
    {
      week: 'Weeks 2 – 4',
      title: 'Transitional Stage',
      details: 'Eyes open (around day 8–12), deciduous incisors erupt, and auditory canals open. Kittens take their first unsteady steps and start responding to sounds.'
    },
    {
      week: 'Weeks 4 – 8',
      title: 'Critical Socialization Window',
      details: 'Peak sensory discovery. Voluntary elimination begins, weaning starts with wet food slurry, and peer play teaches bite inhibition and claw control.'
    },
    {
      week: 'Weeks 8 – 14',
      title: 'Juvenile & Independence Period',
      details: 'Full motor coordination develops. Core vaccinations (FVRCP) begin. Positive exposure to human handling, sounds, and surfaces cements lifelong resilience.'
    },
    {
      week: '6 Months & Beyond',
      title: 'Adolescence to Maturity',
      details: 'Sexual maturity is reached; spaying/neutering is critical to prevent unwanted litters and health complications. Permanent teeth settle.'
    }
  ];

  return (
    <section className="section-panel">
      <div className="section-header">
        <h2>Kitten Developmental Milestones</h2>
        <p>Early neurodevelopmental periods determine adult feline health, emotional resilience, and behavior.</p>
      </div>
      <div className="timeline-container">
        {stages.map((stage, idx) => (
          <div key={idx} className="timeline-card">
            <div className="timeline-badge">{stage.week}</div>
            <h3>{stage.title}</h3>
            <p>{stage.details}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default KittenDevelopment;